import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const LOCALE_KEY = 'locale'

export type Locale = 'ko' | 'en'

interface LocaleState {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'ko',
      setLocale: (locale) => set({ locale }),
    }),
    { name: 'locale-storage', skipHydration: true }
  )
)

export function getStoredLocale(): Locale {
  if (typeof window === 'undefined') return 'ko'
  try {
    const raw = localStorage.getItem('locale-storage')
    if (!raw) return 'ko'
    const parsed = JSON.parse(raw) as { state?: { locale?: string } }
    const locale = parsed?.state?.locale
    return locale === 'en' ? 'en' : 'ko'
  } catch {
    return 'ko'
  }
}
